module.exports = __webpack_public_path__ + "img/page-11.eb0145f0.jpg";